module.exports = __webpack_public_path__ + "static/media/watched.c7fec1a0.svg";